import script from "./UpdateEmployees.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdateEmployees.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__